<template>
  <div class="modal_primary_flora">
    <div class="close" @click="hideModal()"></div>
    <h1>Flora</h1>
    <img src="/img/flora.jpg" alt="">
    <p style="text-align: center;margin-top: 20px;">Próximamente</p>
  </div>
</template>

<script>
import { modalHide } from '@/helpers/animations';

export default {
  name: 'ModalPrimary',
  methods:{
    hideModal: function(){
      modalHide(document.querySelector('.modal_primary_flora'),'primary');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal_primary_flora{
  position: absolute;
  z-index: 2;
  background-color: #2B282C;
  width:280px;
  left: 50%;
  top:50%;
  transform: translate(-50%,-50%) scale(0);
  display: flex;
  flex-direction: column;
}
.modal_primary_flora > h1{
  font-family: 'cervo';
  margin-left: 15px;
  margin-bottom: 15px;
  color:#fff
}
.modal_primary_flora > p{
  font-family: 'garamond';
  padding: 15px;
  margin-bottom: 15px;
  color:#fff;
  font-size: 18px;
}

</style>
